export default "__VITE_ASSET__B6xgs3r5__"